import React from "react";
import { TbCalendar } from "react-icons/tb";
import { MdArrowForward } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function List({ list, path, click }) {
	const navigate = useNavigate();

	return (
		<>
			{list &&
				list.map((item, index) => (
					<div
						key={index}
						onClick={() => { return click ? click(item, index) : navigate(`/${path}/${item._id}`) }}
						className="flex flex-1 w-full pb-3 pt-4 justify-between items-center hover:bg-gray-200/50">
						<div className="flex">
							<div className="mx-1">
								<TbCalendar size={24} />
							</div>
							<div className="w-full min-w-max">{item.name}</div>
						</div>
						<div className="flex">
							{item.price && <div className="mr-2">{item.price}</div>}
							{item.rate && <div className="mr-2">{item.rate}</div>}
							<MdArrowForward className="mx-1" size={24} />
						</div>
					</div>
				))}
		</>
	);
}

export default List;
